import { fetchBaseQueryWrapper } from "@/services/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";

export interface IBackdatingSettingsDto {
  maxBackdateDays: number;
}

const TAG_TYPES = {
  backdating: "BackdatingSettings",
} as const;

const normalizeResponse = (
  data?: IBackdatingSettingsDto | number
): IBackdatingSettingsDto => {
  if (typeof data === "number") {
    return { maxBackdateDays: data };
  }

  if (data?.maxBackdateDays !== undefined) {
    return data as IBackdatingSettingsDto;
  }

  return { maxBackdateDays: 0 };
};

export const backdatingApi = createApi({
  reducerPath: "backdatingApi",
  baseQuery: fetchBaseQueryWrapper({
    path: "backdating",
  }),
  tagTypes: [TAG_TYPES.backdating],
  endpoints: (build) => ({
    getBackdatingSettings: build.query<IBackdatingSettingsDto, void>({
      query: () => "",
      transformResponse: ({ data }: { data?: IBackdatingSettingsDto | number }) =>
        normalizeResponse(data),
      providesTags: [TAG_TYPES.backdating],
    }),
    saveBackdatingSettings: build.mutation<
      IBackdatingSettingsDto,
      IBackdatingSettingsDto
    >({
      query: (body) => ({
        url: "",
        method: "PUT",
        body,
      }),
      invalidatesTags: [TAG_TYPES.backdating],
    }),
  }),
});

export const {
  useGetBackdatingSettingsQuery,
  useSaveBackdatingSettingsMutation,
} = backdatingApi;

